"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mustTextBeShortened = void 0;
const ProductType_1 = __importDefault(require("../../../js/enums/ProductType"));
const license_1 = require("../../../js/helper/license");
const LicenseStore_1 = __importDefault(require("../../../js/stores/LicenseStore"));
const string_1 = require("./string");
const mustTextBeShortened = (license) => {
    const productType = (0, string_1.slugifyKey)(license.productType);
    if (!!license.fileName && !((0, license_1.isMindProductType)(productType) && !(0, license_1.isSoftLock)(license.lockType))) {
        return false;
    }
    const mustNotBeShortened = LicenseStore_1.default.deactivateEllipsis.includes(license.id);
    if (mustNotBeShortened && ProductType_1.default.PRIMECENTER === productType) {
        return false;
    }
    return !license?.activated;
};
exports.mustTextBeShortened = mustTextBeShortened;
